module.exports = __webpack_public_path__ + "img/img.486a745d.png";